import { render, staticRenderFns } from "./ServiceCards.vue?vue&type=template&id=210dd78b&scoped=true&"
var script = {}
import style0 from "./ServiceCards.vue?vue&type=style&index=0&id=210dd78b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210dd78b",
  null
  
)

export default component.exports